import Vue from 'vue'
import Vuex from 'vuex'
import summary from "./modules/summary"
Vue.use(Vuex)
export default new Vuex.Store({
  strict: true,
  modules: {
      summary
  }
});

